module.exports = __webpack_public_path__ + "images/emoji/boy.e017dadb6a522b7e58c0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/boy.png
// module id = Wx6y
// module chunks = 2